export const STATES = [
  {
    n: 'Alabama',
    c: 'AL',
  },
  {
    n: 'Alaska',
    c: 'AK',
  },
  {
    n: 'American Samoa',
    c: 'AS',
  },
  {
    n: 'Arizona',
    c: 'AZ',
  },
  {
    n: 'Arkansas',
    c: 'AR',
  },
  {
    n: 'California',
    c: 'CA',
  },
  {
    n: 'Colorado',
    c: 'CO',
  },
  {
    n: 'Connecticut',
    c: 'CT',
  },
  {
    n: 'Delaware',
    c: 'DE',
  },
  {
    n: 'District Of Columbia',
    c: 'DC',
  },
  {
    n: 'Federated States Of Micronesia',
    c: 'FM',
  },
  {
    n: 'Florida',
    c: 'FL',
  },
  {
    n: 'Georgia',
    c: 'GA',
  },
  {
    n: 'Guam',
    c: 'GU',
  },
  {
    n: 'Hawaii',
    c: 'HI',
  },
  {
    n: 'Idaho',
    c: 'ID',
  },
  {
    n: 'Illinois',
    c: 'IL',
  },
  {
    n: 'Indiana',
    c: 'IN',
  },
  {
    n: 'Iowa',
    c: 'IA',
  },
  {
    n: 'Kansas',
    c: 'KS',
  },
  {
    n: 'Kentucky',
    c: 'KY',
  },
  {
    n: 'Louisiana',
    c: 'LA',
  },
  {
    n: 'Maine',
    c: 'ME',
  },
  {
    n: 'Marshall Islands',
    c: 'MH',
  },
  {
    n: 'Maryland',
    c: 'MD',
  },
  {
    n: 'Massachusetts',
    c: 'MA',
  },
  {
    n: 'Michigan',
    c: 'MI',
  },
  {
    n: 'Minnesota',
    c: 'MN',
  },
  {
    n: 'Mississippi',
    c: 'MS',
  },
  {
    n: 'Missouri',
    c: 'MO',
  },
  {
    n: 'Montana',
    c: 'MT',
  },
  {
    n: 'Nebraska',
    c: 'NE',
  },
  {
    n: 'Nevada',
    c: 'NV',
  },
  {
    n: 'New Hampshire',
    c: 'NH',
  },
  {
    n: 'New Jersey',
    c: 'NJ',
  },
  {
    n: 'New Mexico',
    c: 'NM',
  },
  {
    n: 'New York',
    c: 'NY',
  },
  {
    n: 'North Carolina',
    c: 'NC',
  },
  {
    n: 'North Dakota',
    c: 'ND',
  },
  {
    n: 'Northern Mariana Islands',
    c: 'MP',
  },
  {
    n: 'Ohio',
    c: 'OH',
  },
  {
    n: 'Oklahoma',
    c: 'OK',
  },
  {
    n: 'Oregon',
    c: 'OR',
  },
  {
    n: 'Palau',
    c: 'PW',
  },
  {
    n: 'Pennsylvania',
    c: 'PA',
  },
  {
    n: 'Puerto Rico',
    c: 'PR',
  },
  {
    n: 'Rhode Island',
    c: 'RI',
  },
  {
    n: 'South Carolina',
    c: 'SC',
  },
  {
    n: 'South Dakota',
    c: 'SD',
  },
  {
    n: 'Tennessee',
    c: 'TN',
  },
  {
    n: 'Texas',
    c: 'TX',
  },
  {
    n: 'Utah',
    c: 'UT',
  },
  {
    n: 'Vermont',
    c: 'VT',
  },
  {
    n: 'Virgin Islands',
    c: 'VI',
  },
  {
    n: 'Virginia',
    c: 'VA',
  },
  {
    n: 'Washington',
    c: 'WA',
  },
  {
    n: 'West Virginia',
    c: 'WV',
  },
  {
    n: 'Wisconsin',
    c: 'WI',
  },
  {
    n: 'Wyoming',
    c: 'WY',
  },
];
